import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import * as React from 'react';
import Preview from './preview';

var PreviewGroup = function PreviewGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      previewType = _ref.previewType,
      operations = _ref.operations;
  var images = React.useMemo(function () {
    var _context;

    return React.Children.count(children) > 1 ? _mapInstanceProperty(_context = _filterInstanceProperty(children).call(children, function (image) {
      return image.props.src;
    })).call(_context, function (image) {
      return image.props;
    }) : [children ? children.props : {}];
  }, [children]); // eslint-disable-next-line react-hooks/rules-of-hooks

  var refs = _mapInstanceProperty(images).call(images, function () {
    return React.useRef();
  });

  var _React$useState = React.useState(images[0]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      image = _React$useState2[0],
      setImage = _React$useState2[1];

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      current = _React$useState4[0],
      setCurrent = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      exit = _React$useState6[0],
      setExit = _React$useState6[1];

  React.useEffect(function () {
    exit && setVisible(true);
  }, [exit]);
  React.useEffect(function () {
    setImage(images[current]);
  }, [current, images]);

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      visible = _React$useState8[0],
      setVisible = _React$useState8[1];

  var _React$useState9 = React.useState(''),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      transformOrigin = _React$useState10[0],
      setTransformOrigin = _React$useState10[1];

  var calcTransformOrigin = function calcTransformOrigin(element) {
    var _context2;

    var transformOriginX = element && element.getBoundingClientRect().x + element.getBoundingClientRect().width / 2;
    var transformOriginY = element && element.getBoundingClientRect().y + element.getBoundingClientRect().height / 2;
    setTransformOrigin(_concatInstanceProperty(_context2 = "".concat(transformOriginX, "px ")).call(_context2, transformOriginY, "px"));
  };

  var onPreview = function onPreview(index) {
    setCurrent(index);
    calcTransformOrigin(refs[index].current);
    exit ? setVisible(true) : setExit(true);
  };

  var onClose = function onClose() {
    return setVisible(false);
  };

  var onNext = function onNext() {
    return current < images.length - 1 && setCurrent(current + 1);
  };

  var onPrevious = function onPrevious() {
    return current > 0 && setCurrent(current - 1);
  };

  var alt = image.alt,
      src = image.src,
      previewStyle = image.previewStyle,
      previewClassName = image.previewClassName,
      previewOperations = image.previewOperations;
  var previewProps = {
    alt: alt,
    src: src,
    visible: visible,
    current: current,
    type: previewType,
    length: images.length,
    style: _extends(_extends({}, previewStyle || style), {
      transformOrigin: transformOrigin
    }),
    className: previewClassName || className,
    operations: previewOperations || operations,
    onNext: onNext,
    onClose: onClose,
    onPrevious: onPrevious
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, images.length > 1 ? _mapInstanceProperty(children).call(children, function (image, index) {
    return /*#__PURE__*/React.cloneElement(image, {
      key: image.key || index,
      preview: false,
      ref: refs[index],
      onClick: onPreview.bind(null, index)
    });
  }) : children, exit && /*#__PURE__*/React.createElement(Preview, _extends({}, previewProps)));
};

export default PreviewGroup;